var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8368 10.8368C11.9526 9.72106 13.7617 9.72106 14.8775 10.8368L30 25.9595L45.1226 10.8368C46.2384 9.72106 48.0475 9.72106 49.1632 10.8368C50.2789 11.9526 50.2789 13.7617 49.1632 14.8775L34.0406 30L49.1632 45.1226C50.2789 46.2384 50.2789 48.0475 49.1632 49.1632C48.0475 50.2789 46.2384 50.2789 45.1226 49.1632L30 34.0406L14.8775 49.1632C13.7617 50.2789 11.9526 50.2789 10.8368 49.1632C9.72106 48.0475 9.72106 46.2384 10.8368 45.1226L25.9595 30L10.8368 14.8775C9.72106 13.7617 9.72106 11.9526 10.8368 10.8368Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.36a4f26cb1225f3943c17d3ea31161c0.svg";
export { ForwardRef as ReactComponent };